import { useEffect, useRef } from 'react'
import { useVirtualizer } from '../../hooks/use-virtualizer.tsx'
import { Text } from '../text/text.tsx'
import { MultiselectPopoutOption } from './multiselect-popout-option.tsx'
import { useMultiselectContext } from './use-multiselect.ts'
import { multiselectOptionHeight } from './utils.ts'
const optionHeight = multiselectOptionHeight()

export const MultiselectPopoutOptions = () => {
  const { allRows, initialOptionCount, onLoadRemaining, options } =
    useMultiselectContext()

  const scrollRef = useRef<HTMLDivElement>(null)

  const [virtualizer] = useVirtualizer({
    count: options.length,
    getScrollElement: () => scrollRef.current,
    estimateSize: () => optionHeight,
    overscan: 10,
  })

  // we're delaying loading the rest to make opening the popout faster
  useEffect(() => {
    const [lastItem] = [...virtualizer.getVirtualItems()].reverse()

    if (!lastItem) {
      return
    }

    if (
      lastItem.index === initialOptionCount - 1 &&
      allRows.length > initialOptionCount
    ) {
      onLoadRemaining()
    }
  })

  if (options.length === 0) {
    return (
      <div className="overflow-y-auto hide-scroll px-8 py-4">
        <Text textColor="tertiary">No options match your search!</Text>
      </div>
    )
  }

  return (
    <div ref={scrollRef} className="overflow-y-auto scroll-thin">
      <div
        className="relative w-full"
        style={{ height: virtualizer.getTotalSize() }}
      >
        {virtualizer.getVirtualItems().map((virtualRow) => {
          const option = options[virtualRow.index]
          if (!option) {
            return null
          }
          return (
            <MultiselectPopoutOption
              key={virtualRow.key}
              item={option}
              virtualItem={virtualRow}
            />
          )
        })}
      </div>
    </div>
  )
}
